<div class="widget">
  <div class="amSuite-widget-header">
    {{ 'widgets.last-used.title' | translate }}
  </div>

  <div class="amSuite-widget-block height-auto">
    @if (hasLastTemplates() || !modify) {
    <table class="table table-sm">
      <tbody>
        @for (t of lastTemplates; track $index) {
        <tr>
          <td>
            {{ t.name }}
          </td>
          <td>{{t.description}}</td>
          <td>{{t.package}}</td>
        </tr>
        }
      </tbody>
    </table>
    }
    @if (!hasLastTemplates() || modify) {
    <p>
      {{ 'app.noData' | translate }}
    </p>
    }
  </div>
</div>